import { jsx as _jsx } from "react/jsx-runtime";
import { Radio, RadioGroup as ChakraRadioGroup, Stack } from '@chakra-ui/react';
const RadioGroupFC = ({ value, options = [], isDisabled, onChange, sx }) => {
    return (_jsx(ChakraRadioGroup, { onChange: onChange, value: value, sx: sx, children: _jsx(Stack, { gap: '4px', children: options?.map((opt) => (_jsx(Radio, { value: opt.value, isDisabled: isDisabled || opt.readonly, children: opt.label }, opt.value))) }) }, value));
};
export const RadioGroup = RadioGroupFC;
//# sourceMappingURL=RadioGroup.js.map